export const ALL_COUNTRIES = [
  'AF',
  'AL',
  'DZ',
  'AD',
  'AO',
  'AG',
  'AR',
  'AM',
  'AU',
  'AT',
  'AZ',
  'BS',
  'BH',
  'BD',
  'BB',
  'BY',
  'BE',
  'BZ',
  'BJ',
  'BT',
  'BO',
  'BA',
  'BW',
  'BR',
  'BN',
  'BG',
  'BF',
  'BI',
  'CV',
  'KH',
  'CM',
  'CA',
  'CF',
  'TD',
  'CL',
  'CN',
  'CO',
  'KM',
  'CG',
  'CD',
  'CR',
  'CI',
  'HR',
  'CU',
  'CY',
  'CZ',
  'DK',
  'DJ',
  'DM',
  'DO',
  'EC',
  'EG',
  'SV',
  'GQ',
  'ER',
  'EE',
  'SZ',
  'ET',
  'FJ',
  'FI',
  'FR',
  'GA',
  'GM',
  'GE',
  'DE',
  'GH',
  'GR',
  'GD',
  'GT',
  'GN',
  'GW',
  'GY',
  'HT',
  'HN',
  'HU',
  'IS',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IE',
  'IL',
  'IT',
  'JM',
  'JP',
  'JO',
  'KZ',
  'KE',
  'KI',
  'KP',
  'KR',
  'KW',
  'KG',
  'LA',
  'LV',
  'LB',
  'LS',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'MG',
  'MW',
  'MY',
  'MV',
  'ML',
  'MT',
  'MH',
  'MR',
  'MU',
  'MX',
  'FM',
  'MD',
  'MC',
  'MN',
  'ME',
  'MA',
  'MZ',
  'MM',
  'NA',
  'NR',
  'NP',
  'NL',
  'NZ',
  'NI',
  'NE',
  'NG',
  'MK',
  'NO',
  'OM',
  'PK',
  'PW',
  'PA',
  'PG',
  'PY',
  'PE',
  'PH',
  'PL',
  'PT',
  'QA',
  'RO',
  'RU',
  'RW',
  'KN',
  'LC',
  'VC',
  'WS',
  'SM',
  'ST',
  'SA',
  'SN',
  'RS',
  'SC',
  'SL',
  'SG',
  'SK',
  'SI',
  'SB',
  'SO',
  'ZA',
  'SS',
  'ES',
  'LK',
  'SD',
  'SR',
  'SE',
  'CH',
  'SY',
  'TJ',
  'TZ',
  'TH',
  'TL',
  'TG',
  'TO',
  'TT',
  'TN',
  'TR',
  'TM',
  'TV',
  'UG',
  'UA',
  'AE',
  'GB',
  'US',
  'UY',
  'UZ',
  'VU',
  'VE',
  'VN',
  'YE',
  'ZM',
  'ZW',
  'FO',
  'GG',
  'GI',
  'IM',
  'JE',
  'SJ',
  'VA',
  'XK'
]

export const INTERRAIL_RESIDENCY = [
  'AL',
  'AD',
  'AT',
  'BY',
  'BE',
  'BA',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FO',
  'FI',
  'FR',
  'DE',
  'GI',
  'GR',
  'GG',
  'HU',
  'IS',
  'IE',
  'IM',
  'IT',
  'JE',
  'XK',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'MD',
  'MC',
  'ME',
  'NL',
  'MK',
  'NO',
  'PL',
  'PT',
  'RO',
  'RU',
  'SM',
  'RS',
  'SK',
  'SI',
  'ES',
  'SJ',
  'SE',
  'CH',
  'TR',
  'UA',
  'GB',
  'VA'
]

export const i18n = {
  en: {
    AF: 'Afghanistan',
    AL: 'Albania',
    DZ: 'Algeria',
    AD: 'Andorra',
    AO: 'Angola',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia-Herzegovina',
    BW: 'Botswana',
    BR: 'Brazil',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Cabo Verde',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo-Kinshasa',
    CR: 'Costa Rica',
    CI: "Côte d'Ivoire",
    HR: 'Croatia',
    CU: 'Cuba',
    CY: 'Cyprus',
    CZ: 'Czechia',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    SZ: 'Eswatini',
    ET: 'Ethiopia',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GR: 'Greece',
    GD: 'Grenada',
    GT: 'Guatemala',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HN: 'Honduras',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran',
    IQ: 'Iraq',
    IE: 'Ireland',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'North Korea',
    KR: 'South Korea',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Laos',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MR: 'Mauritania',
    MU: 'Mauritius',
    MX: 'Mexico',
    FM: 'Micronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    MK: 'North Macedonia',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PL: 'Poland',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'São Tomé and Príncipe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States of America',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    FO: 'Faroe Islands',
    GG: 'Guernsey',
    GI: 'Gibraltar',
    IM: 'Isle of Man',
    JE: 'Jersey',
    SJ: 'Svalbard and Jan Mayen',
    VA: 'Vatican City',
    XK: 'Kosovo'
  },
  sv: {
    AF: 'Afghanistan',
    AL: 'Albanien',
    DZ: 'Algeriet',
    AD: 'Andorra',
    AO: 'Angola',
    AG: 'Antigua och Barbuda',
    AR: 'Argentina',
    AM: 'Armenien',
    AU: 'Australien',
    AT: 'Österrike',
    AZ: 'Azerbajdzjan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgien',
    BZ: 'Belize',
    BJ: 'Benin',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnien-Hercegovina',
    BW: 'Botswana',
    BR: 'Brasilien',
    BN: 'Brunei Darussalam',
    BG: 'Bulgarien',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Kap Verde',
    KH: 'Kambodja',
    CM: 'Kamerun',
    CA: 'Kanada',
    CF: 'Centralafrikanska republiken',
    TD: 'Tchad',
    CL: 'Chile',
    CN: 'Kina',
    CO: 'Colombia',
    KM: 'Komorerna',
    CG: 'Kongo',
    CD: 'Kongo-Kinshasa',
    CR: 'Costa Rica',
    CI: 'Elfenbenskusten',
    HR: 'Kroatien',
    CU: 'Kuba',
    CY: 'Cypern',
    CZ: 'Tjeckien',
    DK: 'Danmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominikanska republiken',
    EC: 'Ecuador',
    EG: 'Egypten',
    SV: 'El Salvador',
    GQ: 'Ekvatorialguinea',
    ER: 'Eritrea',
    EE: 'Estland',
    SZ: 'Eswatini',
    ET: 'Etiopien',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'Frankrike',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgien',
    DE: 'Tyskland',
    GH: 'Ghana',
    GR: 'Grekland',
    GD: 'Grenada',
    GT: 'Guatemala',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HN: 'Honduras',
    HU: 'Ungern',
    IS: 'Island',
    IN: 'Indien',
    ID: 'Indonesien',
    IR: 'Iran',
    IQ: 'Irak',
    IE: 'Irland',
    IL: 'Israel',
    IT: 'Italien',
    JM: 'Jamaica',
    JP: 'Japan',
    JO: 'Jordanien',
    KZ: 'Kazakstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'Nordkorea',
    KR: 'Sydkorea',
    KW: 'Kuwait',
    KG: 'Kirgizistan',
    LA: 'Laos',
    LV: 'Lettland',
    LB: 'Libanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libyen',
    LI: 'Liechtenstein',
    LT: 'Litauen',
    LU: 'Luxemburg',
    MG: 'Madagaskar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldiverna',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshallöarna',
    MR: 'Mauretanien',
    MU: 'Mauritius',
    MX: 'Mexiko',
    FM: 'Mikronesien',
    MD: 'Moldavien',
    MC: 'Monaco',
    MN: 'Mongolien',
    ME: 'Montenegro',
    MA: 'Marocko',
    MZ: 'Moçambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Nederländerna',
    NZ: 'Nya Zeeland',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    MK: 'Norra Makedonien',
    NO: 'Norge',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PA: 'Panama',
    PG: 'Papua Nya Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Filippinerna',
    PL: 'Polen',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Rumänien',
    RU: 'Rysska federationen',
    RW: 'Rwanda',
    KN: 'Saint Kitts och Nevis',
    LC: 'Saint Lucia',
    VC: 'Saint Vincent och Grenadinerna',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'São Tomé och Príncipe',
    SA: 'Saudiarabien',
    SN: 'Senegal',
    RS: 'Serbien',
    SC: 'Seychellerna',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakien',
    SI: 'Slovenien',
    SB: 'SalomonÃ¶arna',
    SO: 'Somalia',
    ZA: 'Sydafrika',
    SS: 'Sydsudan',
    ES: 'Spanien',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Surinam',
    SE: 'Sverige',
    CH: 'Schweiz',
    SY: 'Syrien',
    TJ: 'Tadzjikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Östtimor',
    TG: 'Togo',
    TO: 'Tonga',
    TT: 'Trinidad och Tobago',
    TN: 'Tunisien',
    TR: 'Turkiet',
    TM: 'Turkmenistan',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraina',
    AE: 'Förenade Arabemiraten',
    GB: 'Storbritannien',
    US: 'USA',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    YE: 'Jemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    FO: 'Färöarna',
    GG: 'Guernsey',
    GI: 'Gibraltar',
    IM: 'Isle of Man',
    JE: 'Jersey',
    SJ: 'Svalbard och Jan Mayen',
    VA: 'Vatikanstaten',
    XK: 'Kosovo'
  },
  da: {
    AF: 'Afghanistan',
    AL: 'Albanien',
    DZ: 'Algeriet',
    AD: 'Andorra',
    AO: 'Angola',
    AG: 'Antigua og Barbuda',
    AR: 'Argentina',
    AM: 'Armenien',
    AU: 'Australien',
    AT: 'Østrig',
    AZ: 'Aserbajdsjan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Hviderusland',
    BE: 'Belgien',
    BZ: 'Belize',
    BJ: 'Benin',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnien-Hercegovina',
    BW: 'Botswana',
    BR: 'Brasilien',
    BN: 'Brunei Darussalam',
    BG: 'Bulgarien',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Kap Verde',
    KH: 'Cambodja',
    CM: 'Cameroun',
    CA: 'Canada',
    CF: 'Den Centralafrikanske Republik',
    TD: 'Tchad',
    CL: 'Chile',
    CN: 'Kina',
    CO: 'Colombia',
    KM: 'Comorerne',
    CG: 'Kongo',
    CD: 'Congo-Kinshasa',
    CR: 'Costa Rica',
    CI: 'Elfenbenskysten',
    HR: 'Kroatien',
    CU: 'Cuba',
    CY: 'Cypern',
    CZ: 'Tjekkiet',
    DK: 'Danmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Den Dominikanske Republik',
    EC: 'Ecuador',
    EG: 'Egypten',
    SV: 'El Salvador',
    GQ: 'Ækvatorialguinea',
    ER: 'Eritrea',
    EE: 'Estland',
    SZ: 'Eswatini',
    ET: 'Etiopien',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'Frankrig',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgien',
    DE: 'Tyskland',
    GH: 'Ghana',
    GR: 'Grækenland',
    GD: 'Grenada',
    GT: 'Guatemala',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HN: 'Honduras',
    HU: 'Ungarn',
    IS: 'Island',
    IN: 'Indien',
    ID: 'Indonesien',
    IR: 'Iran',
    IQ: 'Irak',
    IE: 'Irland',
    IL: 'Israel',
    IT: 'Italien',
    JM: 'Jamaica',
    JP: 'Japan',
    JO: 'Jordan',
    KZ: 'Kasakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'Nordkorea',
    KR: 'Sydkorea',
    KW: 'Kuwait',
    KG: 'Kirgisistan',
    LA: 'Laos',
    LV: 'Letland',
    LB: 'Libanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libyen',
    LI: 'Liechtenstein',
    LT: 'Litauen',
    LU: 'Luxembourg',
    MG: 'Madagaskar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldiverne',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshalløerne',
    MR: 'Mauretanien',
    MU: 'Mauritius',
    MX: 'Mexico',
    FM: 'Mikronesien',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongoliet',
    ME: 'Montenegro',
    MA: 'Marokko',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Holland',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    MK: 'Nordmakedonien',
    NO: 'Norge',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PA: 'Panama',
    PG: 'Papua Ny Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Filippinerne',
    PL: 'Polen',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Rumænien',
    RU: 'Rusland',
    RW: 'Rwanda',
    KN: 'Saint Kitts og Nevis',
    LC: 'Saint Lucia',
    VC: 'Saint Vincent og Grenadinerne',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'São Tomé og Príncipe',
    SA: 'Saudi-Arabien',
    SN: 'Senegal',
    RS: 'Serbien',
    SC: 'Seychellerne',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakiet',
    SI: 'Slovenien',
    SB: 'Salomonøerne',
    SO: 'Somalia',
    ZA: 'Sydafrika',
    SS: 'Sydsudan',
    ES: 'Spanien',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Surinam',
    SE: 'Sverige',
    CH: 'Schweiz',
    SY: 'Syrien',
    TJ: 'Tadsjikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Østtimor',
    TG: 'Togo',
    TO: 'Tonga',
    TT: 'Trinidad og Tobago',
    TN: 'Tunesien',
    TR: 'Tyrkiet',
    TM: 'Turkmenistan',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'Forenede Arabiske Emirater',
    GB: 'Storbritannien',
    US: 'USA',
    UY: 'Uruguay',
    UZ: 'Usbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    FO: 'Færøerne',
    GG: 'Guernsey',
    GI: 'Gibraltar',
    IM: 'Isle of Man',
    JE: 'Jersey',
    SJ: 'Svalbard og Jan Mayen',
    VA: 'Vatikanstaten',
    XK: 'Kosovo'
  }
}
